<template>
  <div class="img-and-content-container">
    <div class="img-and-content-inner">
      <div class="text-box">
        <h2 class="title">{{ $dt(eleConfig, 'title') }}</h2>
        <a-row :gutter="[24, 24]">
          <a-col v-for="item in eleConfig.dataList" :key="item._id" :span="12">
            <div class="block-title">{{ $dt(item, 'title') }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="img-box">
        <img :src="imgSrc">
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from './componentMixin';

export default {
  name: "specialA",
  mixins: [componentMixin],
  computed: {
    imgSrc() {
      const image = this.$dt(this.eleConfig, 'image') || this.eleConfig.image;
      return image ? this.$Dolphin.path.publicPath + image.filePath : '';
    },
  }
};
</script>

<style scoped lang="scss">
.img-and-content-container {
  width: 100%;
  padding: 96px 0;
  background-color: #fae9f0;

  .img-and-content-inner {
    width: 1280px;
    margin: 0 auto;
    display: flex;

    .text-box {
      flex-shrink: 0;
      width: 600px;
      margin-right: 150px;

      .title {
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 24px;
        line-height: 45px;
        color: #D93379;
      }

      .block-title{
        padding: 30px;
        height: 100%;
        color: white;
        background-color: #D93379;
        text-align: center;
        font-size: 20px;
        line-height: 28px;
      }
    }

    .img-box {
      flex: 1;
      img{
        width: 100%;
      }
    }

  }
}
</style>
